import axios from 'axios';

// // Base URL
// const BASE_URL = 'https://heera1backend.mtscorporate.com';

// Backend URL
const BASE_URL =
  process.env.REACT_APP_API_URL || 'https://backend.rainbitx.com';

// Create axios instance
const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

// Helper to get cookie
const getCookie = (name) => {
  const nameEQ = `${name}=`;
  const cookies = document.cookie.split(';');
  for (let cookie of cookies) {
    cookie = cookie.trim();
    if (cookie.indexOf(nameEQ) === 0) {
      return cookie.substring(nameEQ.length);
    }
  }
  return null;
};

// Request interceptor to add token
api.interceptors.request.use(
  (config) => {
    // Try to get token from cookie first, then localStorage
    let token = getCookie('token');
    if (!token) {
      token = localStorage.getItem('token');
    }

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // If request data is FormData, remove Content-Type to let browser set it
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    if (status === 401) {
      // Allowlist of auth endpoints where 401 is expected (no redirect)
      const AUTH_401_ALLOWLIST = [
        '/api/auth/login',
        '/api/auth/register',
        '/api/auth/verify-email',
        '/api/auth/resend-verification',
        '/api/auth/logout',
      ];

      const reqUrl = error.config?.url || '';
      // Normalize to path regardless of absolute or relative
      let path = reqUrl;
      try {
        if (reqUrl.startsWith('http')) {
          path = new URL(reqUrl).pathname;
        }
      } catch {}

      const isAuthEndpoint = AUTH_401_ALLOWLIST.some((p) => path.includes(p));

      // Only force redirect if we actually have a session token and hit a protected endpoint
      const hasToken = !!(getCookie('token') || localStorage.getItem('token'));

      if (!hasToken || isAuthEndpoint) {
        // Pass the error through for the page to handle (e.g., show toast)
        return Promise.reject(error);
      }

      // Session expired while authenticated – perform a clean logout-style redirect
      try {
        // Clear token cookie (best-effort)
        document.cookie = 'token=; Max-Age=0; path=/';
      } catch {}
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      // Use replace to avoid back navigation loop
      window.location.replace('/login');
      // Still reject so any callers can optionally handle
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

export default api;
